import SpriteSymbol from "../../../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "more",
  "use": "more-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"more\"><g fill=\"none\" fill-rule=\"evenodd\"><path /><g fill=\"var(--bolt-theme-icon, currentColor)\"><path d=\"M14 12a2 2 0 11-4 0 2 2 0 014 0M6 12a2 2 0 11-4 0 2 2 0 014 0M22.1 12a2 2 0 11-4 0 2 2 0 014 0\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol